import Model from "@/app/models/Concerns/Model";

export default class Brand extends Model {
    product_type_id!: number;
    production_order_id!: number;
    isah_id!: string;
    name!: string;

    getTable(): string {
        return "brands";
    }
}
